import { CardSvg } from '@/play/cardSvg'

/** Home card art: a sand mound cut open, pebble creatures with googly eyes buried inside, one dug out. */
export function DigCardArt() {
  const pebble = (cx: number, cy: number, color: string, look: number) => (
    <g>
      <ellipse cx={cx} cy={cy} rx="22" ry="13" fill={color} />
      <circle cx={cx - 8} cy={cy - 9} r="7" fill="#ffffff" stroke="#1d2b36" strokeWidth="1.6" />
      <circle cx={cx + 8} cy={cy - 9} r="7" fill="#ffffff" stroke="#1d2b36" strokeWidth="1.6" />
      <circle cx={cx - 8 + look} cy={cy - 11} r="3.4" fill="#1d2b36" />
      <circle cx={cx + 8 + look} cy={cy - 11} r="3.4" fill="#1d2b36" />
    </g>
  )
  return (
    <CardSvg bg="#bfe6f5">
      <path d="M0 190 C 40 120, 110 60, 170 60 S 290 120, 320 170 L 320 200 L 0 200 Z" fill="#f0e2c2" />
      <path d="M0 200 C 60 160, 120 130, 170 130 S 280 160, 320 190 L 320 200 Z" fill="#e2cfa4" />
      {/* a hole dug down to a found creature */}
      <path d="M182 62 C 186 90, 196 104, 222 106 C 246 104, 252 88, 252 70 C 236 66, 200 62, 182 62 Z" fill="#d9c397" />
      {pebble(218, 110, '#3fb8f0', 2)}
      {/* still hidden: only a hint of colour */}
      <g opacity="0.35">
        <ellipse cx="96" cy="150" rx="20" ry="11" fill="#ff5a5f" />
        <ellipse cx="160" cy="176" rx="18" ry="10" fill="#7cc62a" />
      </g>
      {/* the spade */}
      <g transform="translate(262 18) rotate(28)">
        <rect x="-3" y="0" width="6" height="40" rx="3" fill="#b07a45" />
        <path d="M-14 38 h 28 v 10 a 14 14 0 0 1 -28 0 z" fill="#ff6f61" stroke="#1d2b36" strokeWidth="2" />
      </g>
    </CardSvg>
  )
}
